<template>
  <div class="employee-reference-information-video-block">
    <div class="employee-reference-information-video-block__title" v-html="title" />
    <div class="employee-reference-information-video-block__video-wrapper">
      <iframe width="100%" :src="link" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
  export default {
    name: "VideoBlock",
    props: {
      title: {},
      link: {}
    }
  }
</script>

<style lang="scss">
  .employee-reference-information-video-block{
    flex: 0 1 50%;
    padding: 15px;

    @media screen and (max-width: 980px){
      flex: 0 1 100%;
    }


    &__title {
      line-height: 1.2;
      text-align: center;
      margin-bottom: 15px;
      font-size: 1.5rem;
      font-weight: 500;
      color: rgba(var(--app-heading-color), 1);
    }

    &__video-wrapper{
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .ytp-expand-pause-overlay .ytp-pause-overlay{
          display: none;
        }
      }
    }

  }
</style>
